import { render } from "./evaluationView.vue?vue&type=template&id=b860010e&scoped=true&ts=true"
import script from "./evaluationView.vue?vue&type=script&lang=ts"
export * from "./evaluationView.vue?vue&type=script&lang=ts"

import "./evaluationView.vue?vue&type=style&index=0&id=b860010e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b860010e"]])

export default __exports__